// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"GP-z","inlineTitle":"HP-z","sponsoredAdsWrapper":"IP-z","marketplaceRecosWrapper":"JP-z"};